module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": 'examCurrentModal'
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-success"
  }, [_vm._m(0), _vm._v(" "), (_vm.examResults != null) ? _c('div', [_c('button', {
    staticClass: "btn btn-success pull-left",
    attrs: {
      "type": "button",
      "aria-label": "Refresh"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refreshCurrentResults()
      }
    }
  }, [_vm._v("\n            Osveži\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showExerciseTitle($event)
      }
    }
  }, [_vm._v("\n            Prikazi ime vprasanja\n          ")]), _vm._v(" "), _c('b-dropdown', {
    staticClass: "m-md-2",
    attrs: {
      "text": "Izberi nalogo",
      "variant": "primary"
    }
  }, _vm._l((_vm.examResults.vsaVprasanja), function(vprasanje, i) {
    return _c('div', {
      key: 'vprasanje-' + i
    }, [_c('b-dropdown-item', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showCurrentResultsNextExercise(i)
        }
      }
    }, [(_vm.showNameOfQuestion) ? _c('span', [_vm._v(" " + _vm._s(vprasanje.nameExercise) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.currentStatistics.ExerciseName')) + " " + _vm._s(i + 1))])])], 1)
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "aria-label": "Show Solution"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showSolution()
      }
    }
  }, [_vm._v("\n            Prikazi resitev\n          ")])], 1) : _vm._e()]), _vm._v(" "), (_vm.examResults != null) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.currentStatistics.ExerciseName')) + "\n        "), (_vm.showNameOfQuestion) ? _c('span', [_vm._v(_vm._s(this.examResults.vsaVprasanja[this.exerciseNumber].nameExercise) + ": " + _vm._s(_vm._f("pickTranslation")(this.examResults.vsaVprasanja[this.exerciseNumber].titleExercise)))]) : _c('span', [_vm._v(_vm._s(this.exerciseNumber + 1))])]) : _vm._e(), _vm._v(" "), (_vm.examResults != null) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.pickTranslation(_vm.examResults.vsaVprasanja[this.exerciseNumber].fullExerciseData.text))
    }
  }), _vm._v(" "), _vm._l((_vm.examResults.vsaVprasanja[this.exerciseNumber].naloge), function(vprasanje, i) {
    return _c('div', {
      key: 'er-' + vprasanje.nameQuestion,
      staticClass: "form-group"
    }, [_c('div', [(_vm.showNameOfQuestion) ? _c('strong', [_vm._v(_vm._s(vprasanje.nameQuestion))]) : _c('strong', [_vm._v("Vprasanje " + _vm._s(i + 1) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.pickTranslation(_vm.examResults.vsaVprasanja[_vm.exerciseNumber].fullExerciseData.questions[i].text))
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('exercise-results-preview', {
      attrs: {
        "question": vprasanje,
        "results": _vm.resultsPerExercise[i],
        "resultLabels": _vm.answersOfExercise[i],
        "labelColors": _vm.chartColors[i]
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.correctAnswer[i] != null) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('pages.exams.currentStatistics.answer')))]), _vm._v(_vm._s(_vm.correctAnswer[i]) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.examResults.vsaVprasanja[_vm.exerciseNumber].naloge[i].typeQuestion == 'multichoice') ? _c('div', {
      staticClass: "box box-success"
    }, [_c('bar', {
      attrs: {
        "height": 125,
        "chartData": {
          labels: _vm.answersOfExercise[i],
          datasets: _vm.resultsPerExercise[i]
        },
        "options": {
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              stepSize: 1
            }]
          },
          legend: {
            display: false
          }
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.examResults.vsaVprasanja[_vm.exerciseNumber].naloge[i].typeQuestion == 'radio' || _vm.examResults.vsaVprasanja[_vm.exerciseNumber].naloge[i].typeQuestion == 'numerical' || _vm.examResults.vsaVprasanja[_vm.exerciseNumber].naloge[i].typeQuestion == 'multichoice') ? _c('div', {
      attrs: {
        "id": "bar-chart"
      }
    }, [_c('b-progress', {
      staticClass: "mt-2",
      attrs: {
        "height": "15px",
        "max": 100
      }
    }, [_c('b-progress-bar', {
      staticStyle: {
        "background-color": "#4aa362"
      },
      attrs: {
        "value": 100 * (vprasanje.results[1] / (vprasanje.results[0] + vprasanje.results[1]))
      }
    }), _vm._v(" "), _c('b-progress-bar', {
      staticStyle: {
        "background-color": "#da7162"
      },
      attrs: {
        "value": 100 * (vprasanje.results[0] / (vprasanje.results[0] + vprasanje.results[1]))
      }
    })], 1), _vm._v(" "), ((vprasanje.results[0] + vprasanje.results[1]) > 0) ? _c('div', [_c('span', {
      staticStyle: {
        "font-size": "150%",
        "color": "#4aa362"
      }
    }, [_vm._v(_vm._s(Math.round(100 * (vprasanje.results[1] / (vprasanje.results[0] + vprasanje.results[1])))) + "%")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "150%",
        "color": "#da7162",
        "position": "absolute",
        "right": "45px"
      }
    }, [_vm._v(_vm._s(Math.round(100 * (vprasanje.results[0] / (vprasanje.results[0] + vprasanje.results[1])))) + "%")])]) : _c('div', [_c('span', {
      staticStyle: {
        "font-size": "150%",
        "color": "lightgray"
      }
    }, [_vm._v(_vm._s(0) + "%")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "150%",
        "color": "lightgray",
        "position": "absolute",
        "right": "45px"
      }
    }, [_vm._v(_vm._s(0) + "%")])])], 1) : _vm._e(), _vm._v(" "), (_vm.toggleSolution) ? _c('div', [(!_vm.examResults.vsaVprasanja[_vm.exerciseNumber].fullExerciseData.questions[i].solution) ? _c('div', [_vm._v(_vm._s(_vm.$t('pages.exercise.answers.noSolution')))]) : (_vm.examResults.vsaVprasanja[_vm.exerciseNumber].fullExerciseData.parent != null && _vm.examResults.vsaVprasanja[_vm.exerciseNumber].fullExerciseData.parent !== null) ? _c('div', [_c('div', [_vm._v(_vm._s(_vm.$t('pages.exercise.answers.parametricSolution2')))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.pickTranslation(_vm.examResults.vsaVprasanja[_vm.exerciseNumber].fullExerciseData.questions[i].solution))
      }
    })]) : _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.pickTranslation(_vm.examResults.vsaVprasanja[_vm.exerciseNumber].fullExerciseData.questions[i].solution))
      }
    })]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.close')))]), _vm._v(" "), (_vm.examResults != null) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.exerciseNumber <= 0,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showCurrentResultsNextExercise(_vm.exerciseNumber - 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.currentStatistics.lastExercise')))]) : _vm._e(), _vm._v(" "), (_vm.examResults != null) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.exerciseNumber >= _vm.examResults.vsaVprasanja.length - 1,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showCurrentResultsNextExercise(_vm.exerciseNumber + 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.currentStatistics.nextExercise')))]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c15fae4e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c15fae4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/group/ExamResultsPreview.vue
// module id = 1433
// module chunks = 1